/**
 * @voltxampere/engine — Wire-Node 4-pin no-op stamp (Sprint 23 B5)
 *
 * Wire-Node MNA matrix'e HİÇBİR contribution yapmaz — admittance yok,
 * source yok, augmented row yok. Kullanıcının 4 pin'i aynı net'e
 * bağlaması ile elektriksel kavşak işlevi mevcut net layer
 * tarafından otomatik üretilir.
 *
 * Stamp body'sinin var olma sebebi: stamp registry'de tip kayıtlı
 * olmadığında `getDCStampOrThrow` exception fırlatır. Wire-Node'lu
 * fixture'ların solve etmesi için no-op fonksiyonu register etmek
 * yeter.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { defineDCStamp } from "../definition.js";
export const wireNodeDCStamp = () => {
    // Intentionally empty — wire-node carries no electrical state at
    // the MNA layer. The visual / topological role is handled by the
    // canvas + net layer.
};
export const wireNodeDCStampDefinition = defineDCStamp("wire-node", wireNodeDCStamp, []);
//# sourceMappingURL=wire-node.js.map